import {NgModule} from '@angular/core';
import {InsolesProviderModelModule} from "./model/insolesProviderModel.module";
import {errorMessages} from "../../core/error/errorMessages";
@NgModule({
    imports: [
        InsolesProviderModelModule,
    ]
})
export class InsoleProviderModule {
    constructor() {
        errorMessages.set('CAM_MACHINE_PROVIDER_PRODUCT_STOCK_UNIT_ALREADY_USED', 'Cette bobine est en cours d\'utilisation sur une autre imprimante.');
        errorMessages.set('CAM_MACHINE_PROVIDER_PRODUCT_STOCK_UNIT_ALREADY_EXITED', 'Cette bobine n\'est plus en stock.');

    }
}


